import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading, refresh } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.user) refresh();
  }, [location.state, refresh]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-obsidian text-white/60 font-mono text-sm">
        <span className="sr-blink">Verifying session…</span>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !user.is_admin) return <Navigate to="/dashboard" replace />;

  return children;
}
